module.exports = __webpack_public_path__ + "static/Party-0ec9bb42b795afa47403b7ffb89554a0.png";